import { render, staticRenderFns } from "./c-l-table.vue?vue&type=template&id=5a51a68d&scoped=true"
import script from "./c-l-table.vue?vue&type=script&lang=js"
export * from "./c-l-table.vue?vue&type=script&lang=js"
import style0 from "./c-l-table.vue?vue&type=style&index=0&id=5a51a68d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51a68d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a51a68d')) {
      api.createRecord('5a51a68d', component.options)
    } else {
      api.reload('5a51a68d', component.options)
    }
    module.hot.accept("./c-l-table.vue?vue&type=template&id=5a51a68d&scoped=true", function () {
      api.rerender('5a51a68d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/list/c-l-table.vue"
export default component.exports